import { render, staticRenderFns } from "./terms_conditions.vue?vue&type=template&id=3c49c02e&scoped=true&"
import script from "./terms_conditions.vue?vue&type=script&lang=js&"
export * from "./terms_conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49c02e",
  null
  
)

export default component.exports